module.exports = __webpack_public_path__ + "static/traceability-bd75283bacdb0b125700bf71068c4cd5.jpg";